<template>
  <div>
    <b-modal
      no-fade
      :visible="visible"
      modal-class="gid-onboarding-modal vehicle-modal"
      centered
      size="lg"
      @hide="onDialogHide"
    >
      <template #modal-header>
        <button type="button" class="close-btn" @click="$emit('cancel')">
          <BIconX />
        </button>
        <p class="step-progress">
          {{
            $t('onboarding.progress', {
              step: stepIndex + 1,
              total: stepsCount,
            })
          }}
        </p>
        <p class="title">{{ $t('onboarding.vehicle-step.title') }}</p>
        <p class="subtitle">
          {{ $t('onboarding.vehicle-step.subtitle') }}
        </p>
      </template>
      <validation-observer ref="observer" slim v-slot="{ handleSubmit }">
        <b-form
          id="vehicleForm"
          @submit.prevent="handleSubmit(validateAndNext)"
        >
          <validation-provider
            :name="$t('onboarding.vehicle-step.vehicle-type')"
            rules=""
            v-slot="validationContext"
          >
            <b-form-group
              :label="$t('onboarding.vehicle-step.vehicle-type')"
              label-class="field-label"
              label-cols-sm="3"
              :invalid-feedback="validationContext.errors[0]"
            >
              <multiselect
                :placeholder="$t('please-select')"
                multiple
                v-model="form.transporter"
                :options="transporterQualifications"
              />
            </b-form-group>
          </validation-provider>
          <b-form-group
            v-if="quickPickTransporter.length || loadingQualifications"
            :label="`${$t('quick-selection')}:`"
            label-class="qp-label"
            class="quick-pick-group"
            label-size="sm"
          >
            <template v-if="!loadingQualifications">
              <b-button
                v-for="(q, index) in quickPickTransporter"
                :key="index"
                size="sm"
                type="button"
                variant="primary"
                class="gid-btn gid-btn--primary chip-btn"
                @click="
                  !form.transporter.includes(q) && form.transporter.push(q)
                "
              >
                {{ q }}
                <BIconPlus class="chip-icon" />
              </b-button>
            </template>
            <template v-else>
              <b-skeleton class="chip-skeleton" width="30%"></b-skeleton>
              <b-skeleton class="chip-skeleton" width="30%"></b-skeleton>
              <b-skeleton class="chip-skeleton" width="30%"></b-skeleton>
            </template>
          </b-form-group>
        </b-form>
      </validation-observer>

      <p class="description mt-4 text-muted skip-notice">
        {{ $t('onboarding.vehicle-step.skip-notice') }}
      </p>
      <template #modal-footer>
        <b-button
          type="button"
          @click="$emit('prev')"
          variant="outline-light"
          class="gid-btn gid-btn--ghost"
        >
          {{ $t('onboarding.actions.back') }}
        </b-button>
        <b-button
          form="vehicleForm"
          type="submit"
          variant="primary"
          class="gid-btn gid-btn--primary"
        >
          {{ $t('onboarding.actions.continue') }}
        </b-button>
        <b-button
          type="button"
          @click="$emit('skip')"
          variant="outline-secondary"
          class="gid-btn"
        >
          {{ $t('onboarding.actions.skip') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { BIconX, BIconPlus } from 'bootstrap-vue';
import Multiselect from 'vue-multiselect';
import { handleFetchError } from '@gid/vue-common/utils';

export default {
  components: {
    BIconX,
    BIconPlus,
    Multiselect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    stepIndex: Number,
    stepsCount: Number,
  },
  data() {
    return {
      loadingQualifications: false,
      transporterQualifications: [],
    };
  },
  async created() {
    await this.fetchQualifications();
  },
  computed: {
    quickPickTransporter() {
      return ['LKW', 'PKW', 'Transporter'].filter((q) =>
        this.transporterQualifications.includes(q),
      );
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      if (dirty || validated) {
        return valid ? null : false;
      }
      return null;
    },
    onDialogHide(bvModalEvent) {
      if (bvModalEvent.trigger === 'backdrop') {
        bvModalEvent.preventDefault();
      }
    },
    validateAndNext() {
      this.$emit('next');
    },
    async fetchQualifications() {
      try {
        this.loadingQualifications = true;

        const { data } = await axios.get(
          '/api/partner/qualifications/all-values/',
        );

        if (!data['Transporter'] || data['Transporter'].length === 0)
          throw new Error('No Transporter qualifications found');

        this.transporterQualifications = data['Transporter'];
      } catch (error) {
        this.$bvToast.toast(
          handleFetchError(error) || this.$t('_errors.general.title'),
          {
            title: this.$t('_errors.general.title'),
            variant: 'danger',
            solid: true,
          },
        );
      } finally {
        this.loadingQualifications = false;
      }
    },
  },
};
</script>
